import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ContainerService } from '../../core/services/container.service';
import { ContainerFormBaseComponent } from '../container-form-base.component';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule, NgIf } from '@angular/common';
import { ContainerType } from '../../core/models/container-type.model';
import { ContainerTypeService } from '../../core/services/container-type.service';
import { Client } from '../../core/models/client.model';
import { ClientService } from '../../core/services/client.service';
import { ContainerOwnerService } from '../../core/services/container-owner.service';
import { response } from 'express';

@Component({
  selector: 'app-container-update',
  templateUrl: './container-update.component.html',
  styleUrls: ['./container-update.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
})
export class ContainerUpdateComponent extends ContainerFormBaseComponent implements OnInit {
  containerTypes: ContainerType[] = [];
  clients: Client[] = [];
  containerOwners: any[] = [];
  containerId: number | null = null;

  constructor(
    protected override fb: FormBuilder,
    private containerService: ContainerService,
    private containerTypeService: ContainerTypeService,
    private clientService: ClientService,
    private containerOwnerService: ContainerOwnerService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.loadContainerTypes();
    this.loadClient();
    this.loadContainerOwners();
    this.containerId = this.route.snapshot.params['id'];
    if (this.containerId) {
      this.loadContainerData(this.containerId);
    }
  }

  onSubmit(): void {
    if (this.containerForm.valid && this.containerId) {
      const updatedContainer = this.containerForm.value;
      this.containerService.updateContainer(this.containerId, updatedContainer).subscribe({
        next: response => {
          console.log('Contenedor actualizado:', response);
          this.router.navigate(['/containers']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al actualizar el contenedor:', error.message);
          this.errorMessage = error.error.message || 'Ocurrió un error al actualizar el contenedor';
        },
        complete: () => {
          console.log('Solicitud de actualización de contenedor completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }

  loadContainerData(id: number): void {
    this.containerService.getContainerById(id).subscribe({
      next: container => {
        this.containerForm.patchValue({
          ...container,
          typeContainerId: container.typePackagingId,
        });
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los datos del contenedor:', error.message);
        this.errorMessage =
          error.error.message || 'Ocurrió un error al cargar los datos del contenedor';
      },
    });
  }

  loadContainerTypes(): void {
    this.containerTypeService.getContainerTypes().subscribe({
      next: containerTypes => {
        this.containerTypes = containerTypes;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los tipos de envases:', error.message);
        this.errorMessage =
          error.error.message || 'Ocurrió un error al cargar los tipos de envases';
      },
    });
  }

  loadClient(): void {
    this.clientService.getClients().subscribe({
      next: clients => {
        this.clients = clients;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los clientes:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los clientes';
      },
    });
  }

    loadContainerOwners(): void {
    this.containerOwnerService.getContainerOwners().subscribe({
      next: response => {
        this.containerOwners = response
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los propietarios de contenedores:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los propietarios de contenedores';
      },
    });
  }
}
